export default {
  path: '/',
  name: 'gestalten',
  component: () => import('./StepGestalten.vue'),
  meta: {
    step: {
      label: 'Todesanzeige gestalten',
      sublabel: 'Individuell & Würdevoll',
      showInHeader: true,
      isActive: true,
      requiresEnterValidation: false,
      allowSave: true,
      get store() {
        return useStepStore('gestalten')
      },
    },
  },
} as const satisfies OwnbitConfigurator.Steps.Route<'gestalten'>
